// cookies-dialog.controller.js
"use strict";

class cookiesDialogController {
    constructor() {
        this.editando = false;
    }

    $onInit() {     
        this.analytics = false;
    }

    onAccept() {
        this.accept({analytics:this.analytics});
    }

    onAcceptAll() {
        this.analytics = true;
        this.accept({analytics:this.analytics});
    }
}

cookiesDialogController.$inject = [];

export { cookiesDialogController as COOKIES_DIALOG_CONTROLLER };
